import React from 'react';

import clsx from 'clsx';
import styles from './index.module.scss';

export default function Content({
  children,
  className,
  ...props
}: React.PropsWithChildren & { className?: string }): JSX.Element {
  return <div className={clsx(styles.content, className)} {...props}>{children}</div>;
}
